import { championImageUrl } from '../config';
import type { ChampionSummary } from '../types';

interface Props {
  champion: ChampionSummary;
  size?: number;
  onClick?: (c: ChampionSummary) => void;
  disabled?: boolean;
  title?: string;
}

/** Square champion icon. Renders the name as a fallback if the image fails. */
export default function ChampionIcon({ champion, size = 64, onClick, disabled, title }: Props) {
  const url = championImageUrl(champion.image);
  return (
    <button
      type="button"
      className={`champ-icon${disabled ? ' champ-icon--disabled' : ''}`}
      style={{ width: size, height: size }}
      onClick={() => onClick?.(champion)}
      disabled={disabled}
      title={title ?? `${champion.name} — ${champion.roles.join(', ')}`}
    >
      {url ? (
        <img src={url} alt={champion.name} loading="lazy" width={size} height={size} />
      ) : (
        <span className="champ-icon__fallback">{champion.name}</span>
      )}
    </button>
  );
}
